import escapeRegExp from "lodash/escapeRegExp";

export const exactOrPartialFilter =
  <T>(fields: (keyof T)[]) =>
  (term: string, item: T): boolean => {
    const hasDoubleQuotes =
      term.length >= 2 && term.startsWith('"') && term.endsWith('"');
    const hasSingleQuotes =
      term.length >= 2 && term.startsWith("'") && term.endsWith("'");

    const isQuoted = hasDoubleQuotes || hasSingleQuotes;
    const isExact = isQuoted || term.startsWith("=");

    const needle = (() => {
      if (hasDoubleQuotes || hasSingleQuotes) return term.slice(1, -1);
      if (term.startsWith("=")) return term.slice(1);
      return term;
    })().toLowerCase();

    if (!needle) return true;

    const fieldToString = (v: unknown) => {
      if (v == null) return "";
      if (Array.isArray(v))
        return v.map((t: any) => t?.name ?? t?.id ?? "").join(" ");
      return String(v);
    };

    const allUndefined = fields.every((f) => (item as any)[f] === undefined);
    if (allUndefined) return true;

    if (isExact) {
      return fields.some(
        (f) => fieldToString((item as any)[f]).toLowerCase() === needle,
      );
    } else {
      const re = new RegExp(escapeRegExp(term), "i");
      return fields.some((f) => re.test(fieldToString((item as any)[f])));
    }
  };
